import React, {
  useCallback,
  useMemo,
} from 'react';
import get from 'lodash/get';
import isNil from 'lodash/isNil';

import {
  useGetOne,
  useRecordContext,
  useRedirect,
  ChipField,
  TextField,
  usePermissions,
} from 'react-admin';

import {
  Box,
  Typography,
} from '@mui/material';
import { useScopedEmbeddedViewContext } from '../components/utils/ScopedEmbeddedViewContext';
import actions, { Actions } from '../constants/actions';
import hasAccess from '../utilities/hasAccess';
import PermissionMissing from '../components/utils/PermissionMissing';

const RiskClassField = ({
  chip,
  source,
  label,
}: {
  chip?: boolean;
  source: string;
  label?: string;
  sortable?: boolean;
}) => {
  const record = useRecordContext();

  const score = get(record, source);

  const { permissions } = usePermissions<Actions[]>();
  const hasPermission = useMemo(
    () => hasAccess(permissions, actions.RISK_CLASS_GET),
    [permissions],
  );
  const { data } = useGetOne('risk-classes/from-score', { id: score }, { enabled: !isNil(score) && hasPermission });
  const redirect = useRedirect();

  const handleClick = useCallback(() => {
    redirect('list', 'risk-classes');
  }, [redirect]);

  const scope = useScopedEmbeddedViewContext();
  const shouldLink = !scope.isScopedEmbedded;

  if (!hasPermission) return <PermissionMissing />;

  if (!data) return <Typography>None</Typography>;

  return (
    <Box>
      {chip && (
        <ChipField
          label={label}
          color="neutral"
          onClick={shouldLink ? handleClick : undefined}
          record={data}
          source="name"
        />
      )}
      {!chip && <TextField label={label} record={data} source="name" />}
    </Box>
  );
};

export default RiskClassField;
